import { Chip, Grid, IconButton, Menu, MenuItem, Slider } from '@mui/material';

import { styled } from '@mui/material/styles';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import ErrorIcon from '@mui/icons-material/Error';
import { PlayStatus, SliderMark } from './types';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';
import React, { useState } from 'react';

interface Props {
  selectedTraceIndex: number;
  handleTraceIndexChange: (event: any, index: number | number[]) => void;
  traceHistoryLength: number;
  handleBackwardClicked: () => void;
  handlePlayClicked: () => void;
  handleForwardClicked: () => void;
  handlePauseClicked: () => void;
  handleJumpToNextAlarm?: () => void;
  sliderMarks?: SliderMark[];
  playTimerStatus: PlayStatus;
  playTimerInterval: number;
  setPlayTimerInterval?: React.Dispatch<React.SetStateAction<number>>;
  handleReverseClicked?: () => void;
}

const StyledSlider = styled(Slider)(({ theme }) => ({
  '& .MuiSlider-mark': {
    height: 12,
    width: 2,
    backgroundColor: '#EB0014',
  },
}));

const TraceHistoryPlayBackControls = ({
  selectedTraceIndex,
  handleTraceIndexChange,
  traceHistoryLength,
  handleBackwardClicked,
  handlePlayClicked,
  handleForwardClicked,
  handlePauseClicked,
  handleJumpToNextAlarm,
  sliderMarks,
  playTimerStatus,
  playTimerInterval,
  setPlayTimerInterval,
  handleReverseClicked,
}: Props) => {
  const { data: modules } = useSystemModules({});
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const getSpeedLabel = () => {
    switch (playTimerInterval) {
      case 250:
        return '4x';
      case 500:
        return '2x';
      case 1000:
        return '1x';
      case 2000:
        return '.5x';
      case 4000:
        return '.25x';
      default:
        return '1x';
    }
  };

  const handleMenuClick = (interval: number) => {
    if (setPlayTimerInterval) setPlayTimerInterval(interval);
    setAnchorEl(null);
  };

  return (
    <>
      <Grid item xs={9}>
        <StyledSlider
          value={selectedTraceIndex + 1}
          onChange={(e, value) => handleTraceIndexChange(e, Number(value) - 1)}
          step={1}
          min={1}
          max={traceHistoryLength}
          valueLabelDisplay='auto'
          marks={sliderMarks}
        />
      </Grid>
      <Grid item xs={1}>
        <span>
          {selectedTraceIndex + 1}/{traceHistoryLength}
        </span>
      </Grid>
      <Grid container item xs={12} alignItems='center' justifyContent='center'>
        <IconButton size='small' onClick={handleBackwardClicked}>
          <SkipPreviousIcon style={{ cursor: 'pointer' }} />
        </IconButton>
        {playTimerStatus === PlayStatus.ForwardPaused ||
        playTimerStatus === PlayStatus.BackwardPaused ? (
          <IconButton size='small' onClick={handlePlayClicked}>
            <PlayArrowIcon style={{ cursor: 'pointer' }} />
          </IconButton>
        ) : (
          <IconButton size='small' onClick={handlePauseClicked}>
            <PauseIcon style={{ cursor: 'pointer' }} />
          </IconButton>
        )}
        <IconButton size='small' onClick={handleForwardClicked}>
          <SkipNextIcon style={{ cursor: 'pointer' }} />
        </IconButton>
        {!!setPlayTimerInterval && (
          <Chip
            onClick={handleReverseClicked}
            variant='outlined'
            label={
              playTimerStatus === PlayStatus.Forward ||
              playTimerStatus === PlayStatus.ForwardPaused
                ? 'Forward'
                : 'Reverse'
            }
            style={{ cursor: 'pointer', marginRight: '.2rem' }}
          />
        )}
        {modules?.ADVANCED_HISTORY && sliderMarks && sliderMarks.length > 0 && (
          <IconButton size='small'>
            <ErrorIcon
              onClick={handleJumpToNextAlarm}
              style={{ cursor: 'pointer' }}
            />
          </IconButton>
        )}
        {!!setPlayTimerInterval && (
          <>
            <Chip
              onClick={(e) => setAnchorEl(e.currentTarget)}
              variant='outlined'
              label={getSpeedLabel()}
            ></Chip>
            <Menu
              keepMounted
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              open={!!anchorEl}
              onClose={() => setAnchorEl(null)}
              style={{ zIndex: 999999 }}
            >
              <MenuItem onClick={() => handleMenuClick(4000)}>0.25x</MenuItem>
              <MenuItem onClick={() => handleMenuClick(2000)}>0.5x</MenuItem>
              <MenuItem onClick={() => handleMenuClick(1000)}>1x</MenuItem>
              <MenuItem onClick={() => handleMenuClick(500)}>2x</MenuItem>
              <MenuItem onClick={() => handleMenuClick(250)}>4x</MenuItem>
            </Menu>
          </>
        )}
      </Grid>
    </>
  );
};

export default TraceHistoryPlayBackControls;
